import * as React from "react";
import { singleton } from "logic/singleton";
const SelectedDataLakesContext = React.createContext(void 0);
export default singleton("contexts.SelectedDataLakesContext", () => SelectedDataLakesContext);
